import { G00D00Repository } from '@/context/global/api/repository/g00-d00';
import { AxiosInstance } from 'axios';

export const G00D00MockAPI = (axios: AxiosInstance): G00D00Repository => {
  return {
    Get() {
      return axios.get('https://jsonplaceholder.typicode.com/todos/1', {
        baseURL: '',
      });
    },
  };
};
